/* eslint-disable no-unused-vars */
import {
  Box,
  CircularProgress,
  Pagination,
  PaginationItem,
  Tab,
  Tabs,
} from "@mui/material";
import Typography from "@mui/material/Typography";
import { AsyncPaginate } from "react-select-async-paginate";
import { Container } from "@mui/material";
import {
  PREVIOUS_CONTRACTS_TAB,
  ACTIVE_CONTRACTS_TAB,
  BRIEF,
  HEADER,
  BUTTON,
  TRANSFER_REQUESTS_TAB,
} from "./constants";
import React, { useEffect, useState, useCallback } from "react";
import classNames from "classnames";
// import styled from "@emotion/styled";
import { getContracts } from "../../../setup/api/services/contract";
import ContractsListItem from "../../../components/contractListItem/contractListItem";
import styles from "./list.module.css";
import { EmptyContractsList } from "./emptyContractList";

import {
  ACTIVE_STATUS,
  CLOSED_STATUS,
  COMPLETED_STATUS,
  ESCALATION_STATUS,
  ITEM_ACCEPTED_STATUS,
  RESOLVED_STATUS,
  WAITING_FOR_INSPECTION,
  WAITING_FOR_SHIPPING,
  CANCELED_TRANSACTION,
  CONTRACT_REJECTED,
  WAITING_FOR_SETTLEMENT_CLOSE_STATUS,
  WAITING_FOR_SETTLEMENT_RESOLVE_STATUS,
  OUT_OF_STOCK_STATUS,
  PENDING_APPROVAL,
  PENDING_PAYMENT_VERIFICATION,
} from "../../../components/contractListItem/constants";

import moment from "moment";
import DatePicker from "../../../components/common/DatePicker";
import DropDownAlternate from "../../../components/common/dropDownAlternate";
import SearchInput from "../../../components/common/searchInput";
import { getAccessTokenSync, getUserId } from "../../../setup/auth/oidc";
import { getAllOrganizations } from "../../../setup/api/services/organization";
import { SingleValue } from "react-select";
import { IOrganizations } from "../../../setup/types/Organisation";
import { useTranslation } from "react-i18next";
import { useOrganizationCode } from "../../../setup/util/extractOrganizationCode";

const statuses = [{ id: "ALL_CASES", name: "جميع الحالات" }];

const active_status = [
  { id: "ALL_CASES", name: "جميع الحالات" },
  { id: "CREATED", name: ACTIVE_STATUS },
  { id: "WAITING_FOR_DELIVERY", name: WAITING_FOR_SHIPPING },
  { id: "ITEM_INSPECTION", name: WAITING_FOR_INSPECTION },
  { id: "ITEM_ACCEPTED", name: ITEM_ACCEPTED_STATUS },
  {
    id: "WAITING_FOR_SETTLEMENT_CLOSE",
    name: WAITING_FOR_SETTLEMENT_CLOSE_STATUS,
  },
  {
    id: "WAITING_FOR_SETTLEMENT_RESOLVE",
    name: WAITING_FOR_SETTLEMENT_RESOLVE_STATUS,
  },
  { id: "CANCELED", name: CANCELED_TRANSACTION },
  { id: "DELIVERY_ESCALATION,INSPECTION_ESCALATION", name: ESCALATION_STATUS },
  { id: "OUT_OF_STOCK", name: OUT_OF_STOCK_STATUS },
  {
    id: "RESOLVED_REFUND_CUSTOMER,RESOLVED_RELEASE_PROVIDER",
    name: RESOLVED_STATUS,
  },
  {
    id: "PENDING_APPROVAL",
    name: PENDING_APPROVAL,
  },
  {
    id: "CONTRACT_REJECTED",
    name: CONTRACT_REJECTED,
  },
  {
    id: "PENDING_PAYMENT_VERIFICATION",
    name: PENDING_PAYMENT_VERIFICATION,
  },
];

const closed_status = [
  { id: "ALL_CASES", name: "جميع الحالات" },
  { id: "COMPLETED", name: COMPLETED_STATUS },
  { id: "CLOSED_REFUND_CUSTOMER,CLOSED_RELEASE_PROVIDER", name: CLOSED_STATUS },
];

const ContractsList = () => {
  const { t } = useTranslation();
  const userToken = getAccessTokenSync();
  const [tabType, setTabType] = React.useState("active");
  const [contracts, setContracts] = React.useState([]);
  const [page, setPage] = React.useState(1);
  const [pagesCount, setPagesCount] = React.useState(1);
  const [activeTabPage, setActiveTabPage] = React.useState(1);
  const [prevTabPage, setPrevTabPage] = React.useState(1);
  const pageSize = 10;
  const [searchValue, setSearchValue] = React.useState("");
  const [transactionSearchValue, setTransactionSearchValue] =
    React.useState("");

  const [status, setStatus] = useState<{ id: string | number; name: string }>({
    id: "",
    name: "",
  });

  const [createdAtStart, setCreatedAtStart] = React.useState<any>(null);
  const [createdAtEnd, setCreatedAtEnd] = React.useState<any>(null);

  const [loading, setLoading] = useState<boolean>(false);

  const organizationCode = useOrganizationCode(userToken) || undefined;

  const [organization, setOrganization] = useState<{
    value: string;
    label: string;
  } | null>(
    organizationCode
      ? { value: organizationCode, label: organizationCode }
      : null
  );

  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setTabType(newValue);
    setStatus(statuses[0]);
    if (newValue === "previous") {
      setPage(prevTabPage != 1 ? prevTabPage : 1);
    } else {
      setPage(activeTabPage != 1 ? activeTabPage : 1);
    }
  };

  const handleOrganizationSelected = (
    newValue: SingleValue<{
      value: string;
      label: string;
    }>,
    _
  ) => {
    setOrganization(newValue);
    setPage(1);
  };

  const handlePaginationChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setPage(value);
    if (tabType === "active") {
      setActiveTabPage(value);
    } else {
      setPrevTabPage(value);
    }
  };

  const fetchContracts = useCallback(
    async (
      listType,
      status,
      contractId,
      createdAtTo,
      createdAtFrom,
      referenceTransactionId,
      selectedOrganization
    ) => {
      setLoading(true);
      try {
        const body = {
          listType: listType,
          status: status,
          referenceTransactionId: referenceTransactionId,
          contractId: contractId,
          createdAtTo: createdAtTo
            ? moment(createdAtTo).endOf("day").format("YYYY-MM-DD HH:mm")
            : "",
          createdAtFrom: createdAtFrom
            ? moment(createdAtFrom).format("YYYY-MM-DD HH:mm")
            : "",
          page: page - 1,
          size: pageSize,
          organizationCode: selectedOrganization?.value || "",
          isFetchMilestone: tabType === "transfer",
        };
        const response = await getContracts(body);
        setContracts(response.data.content);
        setPagesCount(response.data.totalPages);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    },
    [page, tabType]
  );

  useEffect(() => {
    fetchContracts(
      tabType,
      status?.id,
      searchValue,
      createdAtEnd,
      createdAtStart,
      transactionSearchValue,
      organization
    );
  }, [
    fetchContracts,
    transactionSearchValue,
    searchValue,
    status?.id,
    tabType,
    organization,
  ]);

  const search = useCallback(() => {
    fetchContracts(
      tabType,
      status?.id,
      searchValue,
      createdAtEnd
        ? createdAtEnd
        : moment(new Date()).endOf("day").format("YYYY-MM-DD HH:mm"),
      createdAtStart
        ? createdAtStart
        : moment(new Date()).startOf("day").format("YYYY-MM-DD HH:mm"),
      transactionSearchValue,
      organization
    );
  }, [
    transactionSearchValue,
    createdAtEnd,
    createdAtStart,
    fetchContracts,
    searchValue,
    status,
    tabType,
    organization,
  ]);

  const searchViaStartDate = useCallback(
    (startDate: Date) => {
      fetchContracts(
        tabType,
        status?.id,
        searchValue,
        createdAtEnd
          ? createdAtEnd
          : moment(new Date()).endOf("day").format("YYYY-MM-DD HH:mm"),
        startDate,
        transactionSearchValue,
        organization
      );
    },
    [
      createdAtEnd,
      fetchContracts,
      searchValue,
      status?.id,
      tabType,
      transactionSearchValue,
      organization,
    ]
  );

  const searchViaEndDate = useCallback(
    (endDate: Date) => {
      fetchContracts(
        tabType,
        status?.id,
        searchValue,
        endDate,
        createdAtStart
          ? createdAtStart
          : moment(new Date()).startOf("day").format("YYYY-MM-DD HH:mm"),
        transactionSearchValue,
        organization
      );
    },
    [
      createdAtStart,
      fetchContracts,
      searchValue,
      status?.id,
      tabType,
      transactionSearchValue,
      organization,
    ]
  );

  const loadOptions = async (q: string, _, additional) => {
    const waffyOption = {
      value: "WAFFY",
      label: "WAFFY",
    };
    const response = await getAllOrganizations(additional.page, pageSize, q);
    const options = response.data.content.map((org: IOrganizations) => ({
      value: org.code,
      label: org.name,
    }));

    if (additional.page === 0) {
      options.unshift(waffyOption);
    }

    return {
      options: options,
      hasMore: response.data.totalPages > additional.page + 1,
      additional: {
        page: additional.page + 1,
      },
    };
  };

  return (
    <div className={styles.container}>
      <Container maxWidth="xl">
        <Box justifyContent="right">
          <Typography
            gutterBottom
            variant="h6"
            sx={{
              fontWeight: "700",
              fontSize: "20px",
              color: "#283743",
              padding: "1em 0 0 0",
            }}>
            {HEADER}
          </Typography>
          <Typography
            gutterBottom
            sx={{ color: "#58646D", fontWeight: "400", fontSize: "1em" }}>
            {BRIEF}
          </Typography>
        </Box>

        <div>
          <div className={styles.tabsRow}>
            <div className={styles.tab_container}>
              <Tabs
                style={{ alignItems: "center" }}
                className={styles.tab_wrapper}
                value={tabType}
                onChange={handleTabChange}>
                <Tab
                  value="active"
                  label={ACTIVE_CONTRACTS_TAB}
                  sx={{
                    paddingLeft: "1rem",
                    paddingRight: "1rem",
                    fontSize: { xs: "0.75em", md: "1em" },
                  }}
                />
                <Tab
                  value="previous"
                  label={PREVIOUS_CONTRACTS_TAB}
                  sx={{
                    paddingLeft: "1rem",
                    paddingRight: "1rem",
                    fontSize: { xs: "0.75em", md: "1em" },
                  }}
                />
                <Tab
                  value="transfer"
                  label={TRANSFER_REQUESTS_TAB}
                  sx={{
                    paddingLeft: "1rem",
                    paddingRight: "1rem",
                    fontSize: { xs: "0.75em", md: "1em" },
                  }}
                />
              </Tabs>
              <div
                className={classNames(
                  styles.filter_wrapper,
                  styles.filter_search_bar_tablet
                )}>
                <SearchInput
                  dir="ltr"
                  placeholder={BUTTON.SEARCH}
                  value={searchValue}
                  handleSearchClick={search}
                  handleChange={(event) => {
                    setSearchValue(event.target.value);
                  }}
                />
              </div>
            </div>
            <div className={styles.thirdTab}>
              <div className={styles.filter_drop_down_mobile}>
                <DropDownAlternate
                  data={tabType === "active" ? active_status : closed_status}
                  label={BUTTON.ALL_CASES}
                  shownValue={status?.id === "" ? statuses[0] : status}
                  handleChange={(value) => setStatus(value)}
                />
              </div>
              <div
                className={classNames(
                  styles.filter_wrapper,
                  styles.filter_search_bar_mobile
                )}>
                <SearchInput
                  dir="ltr"
                  placeholder={BUTTON.SEARCH_TRANS}
                  value={transactionSearchValue}
                  handleSearchClick={search}
                  handleChange={(event) => {
                    setTransactionSearchValue(event.target.value);
                  }}
                />
              </div>
              <div
                className={classNames(
                  styles.filter_wrapper,
                  styles.filter_search_bar_mobile
                )}>
                <SearchInput
                  dir="ltr"
                  placeholder={BUTTON.SEARCH}
                  value={searchValue}
                  handleSearchClick={search}
                  handleChange={(event) => {
                    setSearchValue(event.target.value);
                  }}
                />
              </div>
            </div>

            <div className={styles.filter_container}>
              {!organizationCode && (
                <div style={{ marginLeft: "8px" }}>
                  <AsyncPaginate
                    additional={{ page: 0 }}
                    value={organization}
                    loadOptions={loadOptions}
                    onChange={handleOrganizationSelected}
                    placeholder={t("lbl_choose_organisation")}
                    styles={{
                      control: (base) => ({
                        ...base,
                        width: 200,
                        height: "3rem",
                        padding: "0 1rem",
                        border: "1px solid #E2E8EE",
                        borderRadius: "6rem",
                      }),
                    }}
                  />
                </div>
              )}
              <div className={styles.filter_drop_down}>
                <DropDownAlternate
                  data={tabType === "active" ? active_status : closed_status}
                  label={BUTTON.ALL_CASES}
                  shownValue={status?.id === "" ? statuses[0] : status}
                  handleChange={(value) => setStatus(value)}
                />
              </div>
              <div
                className={classNames(
                  styles.filter_wrapper,
                  styles.filter_date_picker
                )}>
                <DatePicker
                  value={createdAtStart}
                  placeholder={BUTTON.START_DATE}
                  handleChange={(date) => {
                    searchViaStartDate(date);
                    setCreatedAtStart(date);
                  }}
                  maxDate={new Date()}
                />
              </div>
              <div
                className={classNames(
                  styles.filter_wrapper,
                  styles.filter_date_picker
                )}>
                <DatePicker
                  value={createdAtEnd}
                  placeholder={BUTTON.END_DATE}
                  handleChange={(date) => {
                    searchViaEndDate(date);
                    setCreatedAtEnd(date);
                  }}
                  maxDate={new Date()}
                />
              </div>
              <div
                className={classNames(
                  styles.filter_wrapper,
                  styles.filter_search_bar
                )}>
                <SearchInput
                  dir="ltr"
                  placeholder={BUTTON.SEARCH_TRANS}
                  value={transactionSearchValue}
                  handleSearchClick={search}
                  handleChange={(event) => {
                    setTransactionSearchValue(event.target.value);
                  }}
                />
              </div>
              <div
                style={{ width: "12rem" }}
                className={classNames(
                  styles.filter_wrapper,
                  styles.filter_search_bar
                )}>
                <SearchInput
                  dir="ltr"
                  placeholder={BUTTON.SEARCH}
                  handleSearchClick={search}
                  value={searchValue}
                  handleChange={(event) => {
                    setSearchValue(event.target.value);
                  }}
                />
              </div>
            </div>
          </div>
          <div className={classNames(styles.listSection)}>
            <Box
              className={classNames(styles.spinner)}
              sx={{ display: loading ? "flex" : "none" }}>
              <CircularProgress />
            </Box>
            {!loading && contracts.length ? (
              contracts.map((contract: any) => {
                return (
                  <div className={styles.list_wrapper} key={contract.id}>
                    <ContractsListItem
                      userId={getUserId() ?? ""}
                      contract={contract}></ContractsListItem>
                  </div>
                );
              })
            ) : (
              <Box
                className={classNames(styles.emptyListContainer)}
                sx={{ display: loading ? "none" : "flex" }}>
                <EmptyContractsList />
              </Box>
            )}
          </div>
        </div>
        <Box
          className={
            contracts.length ? styles.paginatorContainer : styles.hide
          }>
          <Pagination
            count={pagesCount}
            page={page}
            variant="outlined"
            shape="rounded"
            size="medium"
            onChange={handlePaginationChange}
            color="primary"
            siblingCount={1}
            boundaryCount={1}
            renderItem={(item) => (
              <PaginationItem
                {...item}
                sx={{
                  "&.MuiButtonBase-root.Mui-selected": {
                    background: "#078DE7",
                    color: "#FFFFFF",
                    borderColor: "transparent",
                    height: { xs: "2em", md: "3em" },
                    width: { xs: "2em", md: "3em" },
                  },
                  "&.MuiPaginationItem-root.MuiPaginationItem-previousNext": {
                    background: "#283743",
                    color: "#FFFFFF",
                    borderColor: "#283743",
                    fontSize: 16,
                  },
                  "&.MuiPaginationItem-root": {
                    color: "#078DE7",
                    borderColor: "#078DE7",
                    fontSize: 18,
                    fontWeight: 800,
                    height: { xs: "2em", md: "3em" },
                    width: { xs: "2em", md: "3em" },
                    borderRadius: "8px",
                  },
                }}
              />
            )}
          />
        </Box>
      </Container>
    </div>
  );
};

export default ContractsList;
